import { DEFAULT_STEP, MAX_NUMBER, MIN_NUMBER } from '../constants';
import { InputNumberProperty } from '../enums';

const InputNumberProps = {
  props: {
    [InputNumberProperty.MaxNumber]: {
      default: MAX_NUMBER,
      type: Number,
    },
    [InputNumberProperty.MinNumber]: {
      default: MIN_NUMBER,
      type: Number,
    },
    [InputNumberProperty.Step]: {
      default: DEFAULT_STEP,
      type: Number,
    },
  },
};

export default InputNumberProps;
